/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useApiPersistCache } from "hooks/use-api-persist-cache";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "cms/auth/hooks/use-auth";

const AuthGuard = ({ children }) => {
    const { isLoggedIn, logout } = useAuth();
    const navigate = useNavigate();

    useApiPersistCache();

    useEffect(() => {
        if (!isLoggedIn) {
            // TODO: Redirecting to login is an anti pattern. Users can get stuck if they reload the login page
            //       show/interrupt with login instead
            // logout()
            // navigate('login', { replace: true });
            // return <AuthLogin />
        }
    }, [isLoggedIn, navigate, logout]);

    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node,
};

export { AuthGuard };
